// Leadership Skills organized by subcategories
export const LEADERSHIP_SKILLS_CATEGORIES = [
  {
    name: 'Strategic Leadership',
    skills: [
      'Vision Development', 'Strategic Planning', 'Goal Setting',
      'Strategic Thinking', 'Decision Making', 'Risk Assessment',
      'Innovation Leadership', 'Change Management', 'Business Acumen',
      'Strategic Analysis', 'Future Planning', 'Organizational Direction',
      'Strategic Implementation', 'Resource Allocation', 'Strategic Alignment'
    ]
  },
  {
    name: 'Team Leadership',
    skills: [
      'Team Building', 'Team Development', 'Performance Management',
      'Delegation Skills', 'Team Motivation', 'Conflict Resolution',
      'Team Communication', 'Team Coordination', 'Team Empowerment',
      'Team Culture', 'Team Engagement', 'Team Recognition',
      'Team Coaching', 'Team Assessment', 'Team Dynamics'
    ]
  },
  {
    name: 'People Development',
    skills: [
      'Mentoring', 'Coaching', 'Talent Development',
      'Career Planning', 'Skill Assessment', 'Performance Feedback',
      'Growth Facilitation', 'Potential Recognition', 'Development Planning',
      'Learning Support', 'Capability Building', 'Succession Planning',
      'Training Design', 'Knowledge Transfer', 'Development Strategy'
    ]
  },
  {
    name: 'Organizational Leadership',
    skills: [
      'Organizational Development', 'Culture Building', 'Change Leadership',
      'Process Improvement', 'Policy Development', 'Resource Management',
      'Organizational Design', 'Structure Planning', 'Systems Thinking',
      'Corporate Governance', 'Organizational Strategy', 'Business Transformation',
      'Operational Leadership', 'Quality Management', 'Performance Optimization'
    ]
  },
  {
    name: 'Communication Leadership',
    skills: [
      'Executive Communication', 'Public Speaking', 'Presentation Skills',
      'Stakeholder Communication', 'Crisis Communication', 'Change Communication',
      'Vision Communication', 'Strategic Messaging', 'Leadership Presence',
      'Influence Skills', 'Persuasion Skills', 'Negotiation Skills',
      'Communication Strategy', 'Message Clarity', 'Audience Engagement'
    ]
  },
  {
    name: 'Project Leadership',
    skills: [
      'Project Management', 'Resource Planning', 'Timeline Management',
      'Risk Management', 'Stakeholder Management', 'Project Communication',
      'Quality Control', 'Project Coordination', 'Team Leadership',
      'Project Strategy', 'Scope Management', 'Project Execution',
      'Performance Tracking', 'Project Innovation', 'Results Delivery'
    ]
  },
  {
    name: 'Change Leadership',
    skills: [
      'Change Management', 'Transformation Leadership', 'Change Strategy',
      'Change Communication', 'Resistance Management', 'Change Implementation',
      'Organizational Change', 'Cultural Change', 'Process Change',
      'Change Adoption', 'Transition Management', 'Change Support',
      'Change Assessment', 'Change Sustainability', 'Innovation Management'
    ]
  },
  {
    name: 'Ethical Leadership',
    skills: [
      'Ethical Decision Making', 'Integrity Management', 'Values Leadership',
      'Corporate Ethics', 'Social Responsibility', 'Ethical Standards',
      'Compliance Leadership', 'Moral Leadership', 'Trust Building',
      'Transparency', 'Accountability', 'Ethical Culture',
      'Ethical Behavior', 'Ethical Framework', 'Values Alignment'
    ]
  },
  {
    name: 'Crisis Leadership',
    skills: [
      'Crisis Management', 'Emergency Response', 'Risk Leadership',
      'Crisis Communication', 'Decision Making', 'Problem Solving',
      'Stress Management', 'Team Support', 'Resource Management',
      'Stakeholder Management', 'Recovery Planning', 'Crisis Prevention',
      'Crisis Strategy', 'Resilience Building', 'Crisis Resolution'
    ]
  },
  {
    name: 'Innovation Leadership',
    skills: [
      'Innovation Management', 'Creative Leadership', 'Innovation Strategy',
      'Change Leadership', 'Digital Transformation', 'Technology Leadership',
      'Innovation Culture', 'Innovation Process', 'Idea Management',
      'Innovation Development', 'Future Planning', 'Innovation Implementation',
      'Innovation Assessment', 'Innovation Support', 'Innovation Scaling'
    ]
  },
  {
    name: 'Global Leadership',
    skills: [
      'Cultural Intelligence', 'Global Strategy', 'International Business',
      'Cross-cultural Leadership', 'Global Communication', 'Global Operations',
      'Cultural Adaptation', 'Global Team Leadership', 'International Relations',
      'Global Perspective', 'Diversity Leadership', 'Global Innovation',
      'Global Network', 'Global Expansion', 'Global Integration'
    ]
  },
  {
    name: 'Performance Leadership',
    skills: [
      'Performance Management', 'Goal Achievement', 'Results Orientation',
      'Performance Assessment', 'Quality Leadership', 'Productivity Management',
      'Efficiency Improvement', 'Performance Strategy', 'Success Measurement',
      'Performance Culture', 'Excellence Standards', 'Achievement Recognition',
      'Performance Systems', 'Continuous Improvement', 'Performance Innovation'
    ]
  }
];

// Export flattened list for backward compatibility
export const LEADERSHIP_SKILLS = LEADERSHIP_SKILLS_CATEGORIES.reduce(
  (acc, category) => [...acc, ...category.skills],
  [] as string[]
);
